var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    '--launch-text': _vm.$store.state.color.launchText,
    '--launch-gradient-top': _vm.$store.state.color.launchGradientTop,
    '--launch-gradient-bottom': _vm.$store.state.color.launchGradientBottom,
    '--maintenance-logo': _vm.$store.state.color.maintenanceLogo,
    '--maintenance-gradient-top': _vm.$store.state.color.maintenanceGradientTop,
    '--maintenance-gradient-bottom': _vm.$store.state.color.maintenanceGradientBottom,
    '--page-header-text': _vm.$store.state.color.pageHeaderText,
    '--page-header-color': _vm.$store.state.color.pageHeaderColor,
    '--error-header-text': _vm.$store.state.color.errorHeaderText,
    '--error-header-color': _vm.$store.state.color.errorHeaderColor,
    '--button-focus': _vm.$store.state.color.buttonFocus,
    '--positive-button-text': _vm.$store.state.color.positiveButtonText,
    '--positive-button-enabled': _vm.$store.state.color.positiveButtonEnabled,
    '--positive-button-hover': _vm.$store.state.color.positiveButtonHover,
    '--positive-button-active': _vm.$store.state.color.positiveButtonActive,
    '--positive-button-disabled': _vm.$store.state.color.positiveButtonDisabled,
    '--negative-button-enabled': _vm.$store.state.color.negativeButtonEnabled,
    '--negative-button-hover': _vm.$store.state.color.negativeButtonHover,
    '--negative-button-active': _vm.$store.state.color.negativeButtonActive,
    '--shutter-button-text': _vm.$store.state.color.shutterButtonText,
    '--shutter-button-enabled': _vm.$store.state.color.shutterButtonEnabled,
    '--shutter-button-hover': _vm.$store.state.color.shutterButtonHover,
    '--shutter-button-active': _vm.$store.state.color.shutterButtonActive,
    '--shutter-button-disabled': _vm.$store.state.color.shutterButtonDisabled
  }),attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }